import axios from "axios";

const instance = axios.create({
  // THE API (cloud function) URL
  baseURL: 'https://us-central1-clone-fb8e6.cloudfunctions.net/api' 
//   cd ..'http://localhost:5001/clone-fb8e6/us-central1/api'
  //'https://us-central1-challenge-4b2b2.cloudfunctions.net/api'
    // "http://localhost:5001/challenge-4b2b2/us-central1/api",
});

export default instance;